import { capitalize } from 'lodash';

import { formatPhoneNumber } from 'lib/helpers/utility';

import RefreshERA from '../RefreshERA';

const PRACTICE_STATUSES = [
  {
    label: 'Active',
    value: 'active'
  },
  {
    label: 'Inactive',
    value: 'inactive'
  },
  {
    label: 'Pending',
    value: 'pending'
  }
];

const PRACTICE_OPTIONS = {
  queryKey: 'practices.options',
  title: 'Practice',
  placeholder: 'Search practice',
  icon: 'user-mono',
  allowed_operators: ['is', 'is not', 'is any of']
};

export const FILTERS_DEFS = {
  id: {
    title: 'Practice ID',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  practice: PRACTICE_OPTIONS,
  phone: {
    title: 'Phone',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  timezone: {
    title: 'Timezone',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  status: {
    title: 'Status',
    placeholder: 'Search by status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: PRACTICE_STATUSES.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'claim_statuses.options',
    icon: 'status-mono'
  }
};

export const COLUMN_DEFS = [
  { field: 'id', headerName: 'ID', maxWidth: 100 },
  {
    field: 'name',
    headerName: 'Name',
    minWidth: 500,
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'phone',
    headerName: 'Phone',
    valueFormatter: ({ value }) => formatPhoneNumber(value)
  },
  {
    field: 'timezone',
    headerName: 'Timezone',
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'status',
    headerName: 'Status',
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'refresh',
    headerName: 'ERA List',
    cellRenderer: ({ data }) => <RefreshERA data={data} />
  }
];
